import RouteResolver from '%app/js/common/components/RouteResolver';
import routeTree from '../config/routes';

export default new RouteResolver(routeTree);
